package org.hs_soft.runmynesto.domain.model.home.user

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class UserCancellationReasonEnum(
    val id: String
) {
    NO_AUTHORIZATION(id = "0"),
    ONLY_OWN_RECEIPTS(id = "1"),
    ALL_RECEIPTS(id = "2");

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            NO_AUTHORIZATION -> strings.noAuthorization
            ONLY_OWN_RECEIPTS -> strings.onlyOwnReceipts
            ALL_RECEIPTS -> strings.allReceipts
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                NO_AUTHORIZATION -> strings.noAuthorization
                ONLY_OWN_RECEIPTS -> strings.onlyOwnReceipts
                ALL_RECEIPTS -> strings.allReceipts
            }
        }

    companion object {
        fun fromDisplayName(title: String): UserCancellationReasonEnum? =
            UserCancellationReasonEnum.entries.firstOrNull { it.title == title }
    }
}